import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { color, fontSize, lineHeight, space } from 'styled-system';

const UnstyledSubtitle = styled.div<any>`
  ${color};
  ${fontSize};
  ${lineHeight};
  ${space};
`;

const Subtitle = (props: ComponentProps<typeof UnstyledSubtitle>) => (
  <UnstyledSubtitle
    color="sys.neutral.border.hover"
    fontSize={['fs_14', null, 'fs_16', 'fs_18']}
    lineHeight={['lh_20', null, 'lh_22', 'lh_24']}
    mt={['sp_4', 'sp_0']}
    ml={[null, 'sp_12', 'sp_16']}
    {...props}
  />
);

export default Subtitle;
